export const ClinicType = {
  STANDALONE: "STANDALONE",
  CHAIN: "CHAIN",
};

export const Status = {
  PENDING: "PENDING",
  LOCKED: "LOCKED",
  ACTIVE: "ACTIVE",
  ARCHIVED: "ARCHIVED",
};

export const MRP_STATUS = {
  DRAFT: "DRAFT",
  CONVERTED: "CONVERTED",
  CANCELED: "CANCELED",
};

export const PR_STATUS = {
  DRAFT: "DRAFT",
  SENT_TO_ERP: "SENT_TO_ERP",
  PARTIALLY_ORDERED: "PARTIALLY_ORDERED",
  CLOSED: "CLOSED",
  CANCELED: "CANCELED",
};

export const PO_STATUS = {
  DRAFT: "DRAFT",
  PARTIALLY_RECEIVED: "PARTIALLY_RECEIVED",
  CLOSED: "CLOSED",
  EARLY_CLOSED: "EARLY_CLOSED",
  CANCELED: "CANCELED",
};